

<div class="ttmodal" style="min-width: 50vw;">
  <div class="ttmodal__header">
      <span class="ttmodal__title">Asset Document Library Audit Trail</span>
      <i class="material-icons ttmodal__close-button" (click)="onCloseClick()">close</i>
  </div>

 
  <div class="ttmodal__body">    
<div class="ttmodal__header">
      <span class="ttmodal__title">{{Title}}</span>
      </div>
 
      <div  style="overflow-y: auto; height:350px; ">
      <table class="table table--striped table--full-width">
          <thead>             
              <th style="padding: 1px!important;">Date</th>
              <th style="padding: 1px!important;">Action</th>
              <th style="padding: 1px!important;">User</th>
              <th style="padding: 1px!important;">Old Doc</th>
              <th style="padding: 1px!important;">New Doc</th>
            
          </thead>
          
          <tbody>
              <ng-container *ngIf="AuditResult!=null">
               
                      <tr *ngFor="let audit of AuditResult">
                          
                          <td style="padding: 1px!important;">{{audit.ActivityDate}}</td>
                          <td style="padding: 1px!important;">{{audit.Action}}</td>
                          <td style="padding: 1px!important;">{{audit.ModifiedUser}}</td>
                          <td style="padding: 1px!important;">
                            <i *ngIf="audit.OldAttachment_!=''" style="cursor: pointer;vertical-align: bottom; margin-left: 2%; " 
                            class="material-icons" (click)="OpenDoc(audit.OldAttachment_)">description</i>
                          </td>
                          <td style="padding: 1px!important;">
                            <i *ngIf="audit.NewAttachment_!=''" style="cursor: pointer;vertical-align: bottom; margin-left: 2%; " 
                            class="material-icons" (click)="OpenDoc(audit.NewAttachment_)">description</i>
                          </td>


                            
                      </tr>
                        
               
              </ng-container>
          </tbody>
      </table>
      </div>



    
  </div>


  <!-- <div class="ttmodal__footer">
      <a class="button margin-right-8" (click)="onCloseClick()"><span class="button__text">Cancel</span></a>
      <button mat-raised-button color="warn" [class.loading]="savingChanges" [disabled]="DisabledSaveButton" (click)="saveChangesNew()">
        <span class="button__text">Save</span>
      </button>
    </div> -->
</div>
